import React from "react";
import "./DashboardFooter.css";

export default function DashboardFooter() {
  return (
    <footer className="dash-footer">
      <div className="dash-footer-inner">
        <p>&copy; {new Date().getFullYear()} Docmaster. All rights reserved.</p>
        <nav className="dash-footer-links">
          <a href="/privacy-policy">Privacy Policy</a>
          <a href="/terms-conditions">Terms & Conditions</a>
          <a href="/contact-us">Contact Us</a>
        </nav>
      </div>
    </footer>
  );
}
